$(document).ready(function () {
    //Request
    if ($(".stepType01").length) {
        requestInit();
    }

    checkBoxInit();
    gnbInit();

    if ($(".main_inner").length) {
        mainInit();
    }
});

var mainInit = function () {
    var SUPPORT_CSS = $.support.transition, viewportWidth, mainNum = 0, mainMaxNum = 1, mainMaxNum = $(".main_wrap").length;
    var lastWindowHeight = 800, lastWindowWidth = 800;
    $(window).resize(function () {
        if ($(window).height() != lastWindowHeight || $(window).width() != lastWindowWidth) {
            lastWindowHeight = $(window).height();
            lastWindowWidth = $(window).width();
            mainResize();
        }
    }).resize();

    /* 2015-04-24 khjug for dealer main */
    if ($(".main_wrap").hasClass("main_dealer_wrap")) {
        $("a.mainNext, a.mainPrev, .pagingNum").hide();
    }

    $("a.mainNext").on("click", function (e) {
        e.stopPropagation();
        e.preventDefault();
        var idx = mainNum + 1;
        if (idx == mainMaxNum) {
            idx = 0;
        }
        $(".main_wrap").css("display", "none");
        $(".main_wrap").eq(idx).css("display", "block");
        $(".mainCenter .paging ul > li").removeClass("on");
        $(".mainCenter .paging ul").find("li:eq(" + idx + ")").addClass("on");
        $(this).on("keydown", function (e) {
            if (e.keyCode == 9) {
                e.stopPropagation();
                e.preventDefault();
                $(".mainPrev").focus();
                $(this).off("keydown");
            }
        });
        initMainTile(idx);
    });

    $("a.mainPrev").on("click", function (e) {
        e.stopPropagation();
        e.preventDefault();
        var idx = mainNum - 1;
        if (idx < 0) {
            idx = mainMaxNum - 1;
        }
        $(".main_wrap").css("display", "none");
        $(".main_wrap").eq(idx).css("display", "block");
        $(".mainCenter .paging ul > li").removeClass("on");
        $(".mainCenter .paging ul").find("li:eq(" + idx + ")").addClass("on");

        initMainTile(idx);
    });

    $(".share a.btnShare").on("click", function (e) {
        e.stopPropagation();
        e.preventDefault();
        if ($(this).siblings(".shareList").css("display") == "none") {
            $(this).siblings(".shareList").css("display", "block");
        } else {
            $(this).siblings(".shareList").css("display", "none");
        }
    });

    $(".mainRolling").each(function (i, e) {
        clickFnc(this);
        swipeFnc(this);
        clickNav(this);
    });

    var mainSwipe = new onSwipeFnc(".main_wrap .mainCenterWrap .mainCenter");
    mainSwipe.moveEnd = function (evt, dir, phase, swipetype, distance) {
        if (phase == "end") {
            if (dir == "right") {
                var idx = mainNum - 1;
                if (idx < 0) {
                    idx = 0;
                }
                $("a.mainPrev").trigger("click");
            } else if (dir == "left") {
                var idx = mainNum + 1;
                if (idx > mainMaxNum) {
                    idx = mainMaxNum;
                }
                $("a.mainNext").trigger("click");
            }
        }
    };

    function clickFnc(target) {
        $(target).find(".paging ul > li > a ").on("click", function (e) {
            e.stopPropagation();
            e.preventDefault();
            var idx = $(this).parent().index();
            if (viewportWidth > MOBILE_WIDTH) {
                var ob = $(this).parent().parent().parent().siblings(".listWrap");
                var oldOb = $(this).parent().parent().find("li.on").index();
                var newOb = idx;
                if (oldOb != newOb) {
                    ob.find("ul li").css({transform: "rotateY(180deg)", "display": "none"});
                    ob.find("ul li").eq(newOb).css({transform: "", "display": "block"});
                    ob.find("ul").css("animation", "maintile 0.4s linear 0s").css("-webkit-animation", "maintile 0.4s linear 0s").css("-o-animation", "maintile 0.4s linear 0s").css("-ms-animation", "maintile 0.4s linear 0s");
                    setTimeout(function () {
                        ob.find("ul").attr("style", "");
                        ob.find("ul").css("animation", "").css("-webkit-animation", "").css("-o-animation", "").css("-ms-animation", "");
                    }, 400);
                }
            } else {

                $(this).parent().parent().parent().siblings(".listWrap").find("ul > li").css({"display": "none"});
                $(this).parent().parent().parent().siblings(".listWrap").find("ul > li").eq(idx).css({transform: "rotateY(0)", "display": "block"});
            }
            $(this).parent().siblings().removeClass("on");
            $(this).parent().addClass("on");
        });
    }

    function swipeFnc(target) {
        var localglobalSwipe = new onSwipeFnc(target);
        localglobalSwipe.moveEnd = function (evt, dir, phase, swipetype, distance) {
            var targetNum = $(target).find(".paging ul > li.on").index();
            var targetMaxNum = $(target).find(".paging ul > li").length;
            if (phase == "end") {
                if (dir == "right") {
                    var idx = targetNum - 1;
                    if (idx < 0) {
                        idx = targetMaxNum - 1;
                    }
                    $(target).find(".paging ul > li:eq(" + idx + ") > a").trigger("click");
                } else if (dir == "left") {
                    var idx = targetNum + 1;
                    if (idx > targetMaxNum - 1) {
                        idx = 0;
                    }
                    $(target).find(".paging ul > li:eq(" + idx + ") > a").trigger("click");
                }
            }
        };
    }

    /* 2015-04-24 khjung */
    function clickNav(target) {
        if ($(target).find("li").length < 2) {
            $(target).find(".btn_prev").hide();
            $(target).find(".btn_next").hide();
            return false;
        }

        if ($(target).find(".btn_prev")) {
            $(target).find(".btn_prev").on("click", function (e) {
                e.stopPropagation();
                e.preventDefault();
                var targetNum = $(target).find(".paging ul > li.on").index();
                var targetMaxNum = $(target).find(".paging ul > li").length;
                var idx = targetNum - 1;
                if (idx < 0) {
                    idx = targetMaxNum - 1;
                }
                $(target).find(".paging ul > li:eq(" + idx + ") > a").trigger("click");
            });
        }
        if ($(target).find(".btn_next")) {
            $(target).find(".btn_next").on("click", function (e) {
                e.stopPropagation();
                e.preventDefault();
                var targetNum = $(target).find(".paging ul > li.on").index();
                var targetMaxNum = $(target).find(".paging ul > li").length;
                var idx = targetNum + 1;
                if (idx > targetMaxNum - 1) {
                    idx = 0;
                }
                $(target).find(".paging ul > li:eq(" + idx + ") > a").trigger("click");
            });
        }

    }

    function initMainTile(idx) {
        var $divTile = $(".main_wrap").eq(idx).find("> div");
        var delay = 0;
        var delay_kv = 0;
        var tempBoxWidth = 307, tempBoxHeight = 262;
        if (viewportWidth < TABLET_WIDTH) {
            tempBoxWidth = 153;
            tempBoxHeight = 131;
        }
        $divTile.css("animation", "").css("-webkit-animation", "").css("-o-animation", "").css("-ms-animation", "");
        if (SUPPORT_CSS && viewportWidth > MOBILE_WIDTH) {
            $divTile.each(function (i) {
                if (!$(this).hasClass("mainCenterWrap")) {
                    delay = delay + 0.05;
                    $(this).css("animation", "maintile 0.4s linear " + delay + "s").css("-webkit-animation", "maintile 0.4s linear " + delay + "s").css("-o-animation", "maintile 0.4s linear " + delay + "s").css("-ms-animation", "maintile 0.4s linear " + delay + "s");
                } else {
                    var v = ($(this).width() / tempBoxWidth) + 1;
                    var h = ($(this).height() / tempBoxHeight) + 1;
                    var h2 = Math.floor(h / 2);
                    for (var j = 1; j <= h; j++) {
                        for (var i = 1; i <= v; i++) {
                            $(this).find(".mainCenter").append('<div class="ani ani' + i + '_' + j + '" style="position:absolute;left:' + ((i - 1) * tempBoxWidth) + 'px;top:' + ((j - 1) * tempBoxHeight) + 'px;width:' + tempBoxWidth + 'px;height:' + tempBoxHeight + 'px;"></div>');
                        }
                    }
                    for (var j = 1; j <= h; j++) { // h
                        for (var i = 1; i <= v; i++) { // v
                            var ob = $(".ani" + i + "_" + j);
                            if (j < h2) {
                                j2 = h - j + 1;
                            } else {
                                j2 = j;
                            }
                            delay_kv = (100 * i) + (80 * j2);
                            ob.delay(delay_kv).animate({opacity: 0}, 500);
                        }
                    }
                    setTimeout(function () {
                        $(".ani").remove();
                    }, delay_kv + 100);
                }
            });
        } else {
            $divTile.each(function (i) {
                delay = delay + 50;
                $(this).css("animation", "").css("-webkit-animation", "").css("-o-animation", "").css("-ms-animation", "");
                $(this).stop().css("opacity", 0).delay(delay).animate({opacity: 1}, 200, function () {
                    $(this).css("opacity", 1);
                });
            });
        }
        mainNum = idx;
        $(".main_inner .pagingNum > span").html(mainNum + 1);
    }

    function mainPageHide() {
        $(".main_inner .pagingNum").stop().hide();
        $("a.mainNext, a.mainPrev").off("mouseover").on("mouseover", function (e) {
            $(".main_inner .pagingNum").fadeIn();
        });
        $("a.mainNext, a.mainPrev").off("mouseout").on("mouseout", function (e) {
            $(".main_inner .pagingNum").fadeOut();
        });
    }

    function mainPageShow() {
        $(".main_inner .pagingNum").stop().show();
        $("a.mainNext, a.mainPrev").off("mouseover");
        $("a.mainNext, a.mainPrev").off("mouseout");
    }

    function mainResize() {
        document.body.style.overflow = "hidden";
        viewportWidth = $(window).width();
        document.body.style.overflow = "";
        if (IE_VER < 9 && IE_VER !== false) {

        } else {
            if (viewportWidth > TABLET_WIDTH) {
                mainPageHide();
            } else {
                mainPageShow();
            }
        }
    }
};

var requestInit = function () {
    var lastWindowHeight = 800, lastWindowWidth = 800;
    $(window).resize(function () {
        if ($(window).height() != lastWindowHeight || $(window).width() != lastWindowWidth) {
            lastWindowHeight = $(window).height();
            lastWindowWidth = $(window).width();
            requestStep1Resize();
        }
    }).resize();

    if ($(".stepbar.bar01 .car .carList").length < 2) {
        $(".stepbar.bar01 a.btn_carmore").remove();
    }

    $(".stepbar.bar01 a.btn_carmore").on("click", function (e) {
        e.stopPropagation();
        e.preventDefault();
        if ($(this).parent().hasClass("on")) {
            $(this).parent().removeClass("on");
            $(this).parent().find(".carList:not(:eq(0))").css("display", "none");
        } else {
            $(this).parent().addClass("on");
            $(this).parent().find(".carList:not(:eq(0))").css("display", "block");
        }
    });

    function requestStep1Resize() {
        document.body.style.overflow = "hidden";
        var viewportWidth = $(window).width();
        document.body.style.overflow = "";
        if (IE_VER < 9 && IE_VER !== false) {
            //return;
        } else {
            if (viewportWidth < MOBILE_WIDTH) {
                if (!$(".stepbar.bar01 .car").hasClass("on")) {
                    $(".stepbar.bar01 .car .carList:not(:eq(0))").css("display", "none");
                }
            } else {
                $(".stepbar.bar01 .car .carList:not(:eq(0))").css("display", "block");
            }
        }
    }
};

var checkBoxInit = function () {
    $(".check_box").on("click", function (e) {
        e.stopPropagation();
        e.preventDefault();
        var targetFor = $(this).attr("for");
        var targetInput = $("input:checkbox[id=" + targetFor + "]");
        if ($(this).hasClass("c_on")) {
            $(this).removeClass("c_on");
            targetInput.prop("checked", false);
        } else {
            $(this).addClass("c_on");
            targetInput.prop("checked", true);
        }

        //
        var advisorListContainer = $(this).closest(".car_list.advisorList");
        if (advisorListContainer.length > 0) {
            advisorListContainer.trigger("advisorListChk.kia", $(this));
        }
    });

    $("input:checkbox").on("click", function (e) {
        var targetId = $(this).attr("id");
        var targetName = $(this).attr("name");
        var targetLabel = $("label[for='" + targetId + "']");
        if (targetLabel.hasClass("c_on")) {
            targetLabel.removeClass("c_on");
        } else {
            targetLabel.addClass("c_on");
        }
    });
};


var gnbInit = function () {
    var viewportWidth, isMobile = false, carTab = 0, lastWindowHeight = 800, lastWindowWidth = 800;
    $(window).resize(function () {
        if ($(window).height() != lastWindowHeight || $(window).width() != lastWindowWidth) {
            lastWindowHeight = $(window).height();
            lastWindowWidth = $(window).width();
        }
    }).resize();

    $(".dth1_a").on("click", function (e) {
        var hasSub = $(this).siblings(".dth2_u").length;
        if (hasSub) {
            e.stopPropagation();
            e.preventDefault();
            if ($(this).parent().hasClass("dth_on")) {
                if (isMobile) {
                    $(".dth1_l").removeClass("dth_on");
                    dimOpen();
                } else {
                    gnbClose();
                }
            } else {
                $(".gnb_area").addClass("open");
                $(".dth1_l").removeClass("dth_on");
                $(this).parent().addClass("dth_on");
                dimOpen();
                if ($(this).siblings(".dth_pip")) {
                    $(".car_tab > a.sort_a").removeClass("sort_on");
                    $(".car_tab > a.sort_a:eq(" + carTab + ")").addClass("sort_on");
                    carGridSet(carTab);
                }
            }
        }
    });

    $("a.util_a:eq(0)").on("focus", function (e) {
        if ($(window).width() > MOBILE_WIDTH || (IE_VER < 9 && IE_VER !== false)) {
            gnbClose();
        }
    });

    $("a.lg_a").on("focus", function (e) {
        gnbClose();
    });
    $(".dth1_a").on("mousedown", function (e) {
        $(this).data("mouseDown", true);
    });
    $(".dth1_a").on("mouseup", function (e) {
        $(this).removeData("mouseDown");
    });

    $(".dth1_a").on("focus", function (e) {
        if ($(this).data("mouseDown")) {
            return;
        }
        var hasSub = $(this).siblings(".dth2_u").length;
        if (hasSub) {
            e.stopPropagation();
            e.preventDefault();
            $(".gnb_area").addClass("open");
            $(".dth1_l").removeClass("dth_on");
            $(this).parent().addClass("dth_on");
            dimOpen();
            if ($(this).siblings(".dth_pip")) {
                $(".car_tab > a.sort_a").removeClass("sort_on");
                $(".car_tab > a.sort_a:eq(" + carTab + ")").addClass("sort_on");
                carGridSet(carTab);
            }
        }
    });

    $(".gnb_dimmed").on("click", function (e) {
        e.stopPropagation();
        e.preventDefault();
        gnbClose();
    });

    $("a.open_gnb").on("click", function (e) {
        e.stopPropagation();
        e.preventDefault();
        if ($(".gnb_area").hasClass("open")) {
            gnbClose();
        } else {
            $(".gnb_area").addClass("open");
            dimOpen();
        }
    });

    //cartab
    $(".car_tab > a.sort_a").on("click", function (e) {
        e.stopPropagation();
        e.preventDefault();
        $(".car_tab > a.sort_a").removeClass("sort_on");
        $(this).addClass("sort_on");
        var idx = $(this).index();
        carGridSet(idx);
    });

    $("a.sdth1_a").on("click", function (e) {
        $(".sdth1_l").removeClass("sdth_on");
        $(this).parent().addClass("sdth_on");
    });

    //snb type1
    $(".snb_tit > a.open_snb").on("click", function (e) {
        e.stopPropagation();
        e.preventDefault();
        if ($(this).hasClass("open")) {
            $(this).removeClass("open");
            $(".snb_nav").removeClass("open");
        } else {
            $(this).addClass("open");
            $(".snb_nav").addClass("open");
        }
    });

    //snb type2
    $(".snb_area > a.open_snb").on("click", function (e) {
        e.stopPropagation();
        e.preventDefault();
        if ($(this).hasClass("open")) {
            $(this).removeClass("open");
            $(".snb_nav").removeClass("open");
        } else {
            $(this).addClass("open");
            $(".snb_nav").addClass("open");
        }
    });

    $(".sales_kit > a.kit").on("click", function (e) {
        e.stopPropagation();
        e.preventDefault();
        if ($(this).parent().hasClass("open")) {
            $(this).parent().removeClass("open");
        } else {
            $(this).parent().addClass("open");
        }
    });

    function dimOpen() {
        var docH;
        $(".gnb_dimmed").css("height", 0);
        if (IE_VER < 9 && IE_VER !== false) {
            docH = $(document).height() - 94;
        } else {
            if (isMobile) {
                docH = $(document).height() - 41;
            } else {
                docH = $(document).height() - 90;
            }
        }

        $(".gnb_dimmed").css("height", docH);
        $(".gnb_dimmed").show();
    }

    function gnbClose() {
        $(".dth1_l").removeClass("dth_on");
        $(".gnb_area").removeClass("open");
        $(".gnb_dimmed").hide();
    }

    function carGridSet(idx) {
        // 쇼룸 차량 브라우저 넘어갈 때를 위한
        if ($('#header').outerHeight() + $('.dth_pip').height() > $(window).height()) { //차량박스들이 브라우저 높이를 넘어서면
            $(".snb_wrap").css("position", "absolute");
            $(".gnb_dimmed").css("position", "absolute");
            dimOpen();

            if ($(window).scrollTop() !== 0) {
                $(window).scrollTop(0);
            }
        }
        //

        $(".car_grid").removeClass("on");
        $(".car_grid:eq(" + idx + ")").addClass("on");
        carTab = idx;
        if (viewportWidth < MOBILE_WIDTH) {
            return;
        }
        var $carGrid = $(".grid_u:eq(" + idx + ") li.grid_l .grid_box");
        var delay = 0;
        var carGridLen = $carGrid.length - 1;
        TweenMax.killAll();
        $carGrid.each(function (i) {
            delay = delay + 0.06;
            TweenMax.fromTo($(this), 0.4, {transformPerspective: 500, rotationY: 180}, {transformPerspective: 500, rotationY: 0, delay: delay, onComplete: rotateEnd, onCompleteParams: [$(this)]});
        });
        function rotateEnd(self) {
            $(self).css({"transform": ""});
        }
    }
};

/*
 *  @onSwipeFnc
 *  var mainSwipe = new onSwipeFnc(object);
 *  mainSwipe.moveEnd = function(evt, dir, phase, swipetype, distance){};
 *
 */
function onSwipeFnc(el) {
    this.el = el;
    this.init();
}

onSwipeFnc.prototype = {
    init: function () {
        var self = this, touchsurface = $(self.el), dir, swipeType, startX, startY, distX, distY, threshold = 150, restraint = 100, allowedTime = 500, elapsedTime, startTime,
            handletouch = self.callback || function (evt, dir, phase, swipetype, distance) {
            };
        touchsurface.on('touchstart', touchStart);

        function touchStart(e) {
            var touchobj = e.originalEvent.changedTouches[0];
            dir = 'none';
            swipeType = 'none';
            dist = 0;
            startX = touchobj.pageX;
            startY = touchobj.pageY;
            startTime = new Date().getTime();
            touchsurface.on('touchmove', touchMove);
            touchsurface.on('touchend', touchEnd);
        }

        function touchMove(e) {
            var touchobj = e.originalEvent.changedTouches[0];
            distX = touchobj.pageX - startX;
            distY = touchobj.pageY - startY;
            if (Math.abs(distX) > Math.abs(distY)) {
                dir = (distX < 0) ? 'left' : 'right';
                e.preventDefault();
            } else {
                touchsurface.off('touchmove', touchMove);
                touchsurface.off('touchend', touchEnd);
            }
        }

        function touchEnd(e) {
            var touchobj = e.originalEvent.changedTouches[0];
            elapsedTime = new Date().getTime() - startTime;
            if (elapsedTime <= allowedTime) {
                if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) {
                    swipeType = dir;
                } else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint) {
                    swipeType = dir;
                }
            }
            touchsurface.off('touchmove', touchMove);
            touchsurface.off('touchend', touchEnd);
            self.moveEnd(e, dir, 'end', swipeType, (dir == 'left' || dir == 'right') ? distX : distY);
        }
    },

    moveEnd: function (evt, dir, phase, swipetype, distance) {
        this.moveEnd(evt, dir, phase, swipetype, distance);
    }
}

/*
 *  @mainslider
 *  var slider = new mainSlider($object, false, false);
 *  slider.moveEnd = function(dragFlag , disX , conX){};
 *
 */
function mainSlider(obj, limit, css) {
    var self = this;
    this.tar = obj;
    this.limitlast = limit;
    this.usecss3 = css;
    this.init();
}

mainSlider.prototype = {
    init: function () {
        var self = this, sx, sy, conX, disX, disY, interval, dragFlag, scrollLock, firstCheck;
        if (self.usecss3) {
            self.tar.css({"-webkit-transform": "matrix(1,0,0,1,0,0)"});
        }
        self.tar.bind("touchstart", touchstart);

        function mousestart(e) {
            e.stopPropagation();
            clearTimeout(interval);
            setTimeout(setTimer, 200);
            sx = e.pageX;
            sy = e.pageY;
            if (self.usecss3) {
                var wx = matrixToArray(self.tar.css("-webkit-transform"))[4];
            } else {
                var wx = self.tar.css("left");
            }

            conX = parseInt(wx);
            disX = 0;
            dragFlag = false;
            scrollLock = true;
            firstCheck = true;

            self.tar.bind("mousemove", mousemove).bind("mouseup", mouseend);
        }

        function mousemove(e) {
            e.stopPropagation();
            disX = sx - e.pageX;
            disY = sy - e.pageY;

            if (firstCheck) {
                if (Math.abs(disX) > Math.abs(disY)) {
                    scrollLock = false;
                }
            }

            firstCheck = false;
            var scl = self.scrollLock;
            if (scl) {
                scrollLock = true;
            }

            if (!scrollLock) {
                e.preventDefault();
                if (self.usecss3) {
                    var wx = matrixToArray(self.tar.css("-webkit-transform"))[4];
                    if (self.limitlast) {
                        if (targetX > 0) {
                            self.tar.css("-webkit-transform", "matrix(1, 0, 0, 1, 0, 0)");
                            return;
                        } else if (targetX < -self.tar.width()) {
                            self.tar.css("-webkit-transform", "matrix(1, 0, 0, 1, " + (-self.tar.width()) + ", 0)");
                            return;
                        }
                    }
                    var targetX = conX - disX;
                    TweenMax.to(self.tar, 0, {x: targetX});
                } else {
                    var wx = self.tar.css("left");
                    var targetX = conX - disX;
                    TweenMax.to(self.tar, 0, {left: targetX});
                }
            } else {
                self.tar.unbind("mousemove", mousemove).unbind("mouseup", mouseend);
            }
        }

        function mouseend(e) {
            self.tar.unbind("mousemove", mousemove).unbind("mouseup", mouseend);
            e.stopPropagation();
            clearTimeout(interval);
            if (!scrollLock) {
                self.moveEnd(dragFlag, disX, conX);
            }
        }

        function touchstart(e) {
            e.stopPropagation();
            clearTimeout(interval);
            setTimeout(setTimer, 200);
            sx = e.originalEvent.touches[0].pageX;
            sy = e.originalEvent.touches[0].pageY;

            if (self.usecss3) {
                var wx = matrixToArray(self.tar.css("-webkit-transform"))[4];
            } else {
                var wx = self.tar.css("left");
            }

            conX = parseInt(wx);
            disX = 0;
            dragFlag = false;
            scrollLock = true;
            firstCheck = true;

            self.tar.bind("touchmove", touchmove).bind("touchend", touchend);
        }

        function touchmove(e) {
            e.stopPropagation();
            disX = sx - e.originalEvent.touches[0].pageX;
            disY = sy - e.originalEvent.touches[0].pageY;

            if (firstCheck) {
                if (Math.abs(disX) > Math.abs(disY)) {
                    scrollLock = false;
                }
            }

            firstCheck = false;
            var scl = self.scrollLock;
            if (scl) {
                scrollLock = true;
            }

            if (!scrollLock) {
                e.preventDefault();
                if (self.usecss3) {
                    var wx = matrixToArray(self.tar.css("-webkit-transform"))[4];
                    if (self.limitlast) {
                        if (targetX > 0) {
                            self.tar.css("-webkit-transform", "matrix(1, 0, 0, 1, 0, 0)");
                            return;
                        } else if (targetX < -self.tar.width()) {
                            self.tar.css("-webkit-transform", "matrix(1, 0, 0, 1, " + (-self.tar.width()) + ", 0)");
                            return;
                        }
                    }
                    var targetX = conX - disX;
                    TweenMax.to(self.tar, 0, {x: targetX});
                } else {
                    var wx = self.tar.css("left");
                    var targetX = conX - disX;
                    TweenMax.to(self.tar, 0, {left: targetX});
                }
            } else {
                self.tar.unbind("touchmove", touchmove).unbind("touchend", touchend);
            }
        }

        function touchend(e) {
            self.tar.unbind("touchmove", touchmove).unbind("touchend", touchend);
            e.stopPropagation();
            clearTimeout(interval);
            if (!scrollLock) {
                self.moveEnd(dragFlag, disX, conX);
            }
        }

        function setTimer() {
            dragFlag = true;
        }

        function matrixToArray(str) {
            return str.match(/(-?[0-9\.]+)/g);
        }
    },

    destory: function () {
        var self = this;
        self.tar.off();
        self = null;
    },

    moveEnd: function (dragFlag, disX, conX) {
        this.moveEnd(dragFlag, disX, conX);
    },

    scrollLockFlag: function (dragFlag) {
        this.scrollLock = dragFlag;
    }
};

$(function() {
    setInterval(function() {
        $(".btn_next").click();
    }, 8000);
});
